import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { Datapoints } from '../datapoints';

export const clickEditTodoContextMenuItem = action(
    'clickEditTodoContextMenuItem',
    (itemId: string) =>
        addDatapointConfig(Datapoints.todoItemActionContextMenuEditSubject, {
            itemId,
        })
);

export const clickRemoveImportanceContextMenuItem = action(
    'clickRemoveImportanceContextMenuItem',
    (itemId: string) =>
        addDatapointConfig(Datapoints.todoItemActionContextMenuRemoveImportance, {
            itemId,
        })
);

export const clickMarkImportantContextMenuItem = action(
    'clickMarkImportantContextMenuItem',
    (itemId: string) =>
        addDatapointConfig(Datapoints.todoItemActionContextMenuMarkImportant, {
            itemId,
        })
);
